import { DATE, TIME, DATETIME } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'

export default {
  label: 'Is not between',
  operator: 'is not between',
  separator: ' and ',
  fields: [ DATE, TIME, DATETIME ],
  isValidValue (value) {
    return isDate(value) || (isString(value) && value.length)
  }
}
